import React, { useRef, useEffect, useState } from 'react'
import Img from 'gatsby-image'
import PortableText from '@sanity/block-content-to-react'
import styled from 'styled-components'
import SlideCounter from './SlideCounter'
import ReactPlayer from 'react-player'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { TweenMax, Power3, gsap } from 'gsap'
import * as Scroll from 'react-scroll'
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from 'react-scroll'
import mediumZoom from 'medium-zoom'

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const Project = styled.section`
  margin-top: 100vh;
  display: block;
  background: var(--light);
  width:100vw;
  overflow-x:hidden;
  box-sizing: border-box;
  text-align: center;
  position:relative;
  z-index:2;

`

const Slide = styled.section`
  padding-bottom:25vh;
  /* border-top: 1px solid rgb(240, 240, 240); */
  display: block;
  margin: 0;
  box-sizing: border-box;


  h3,
  h2 {
    text-align: center;
    margin: 0;
  }

  .full-bleed-image,
  .grid-image,
  .inset-image {
    /* border-radius: 6px; */
    /* box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3); */
  }

  &.grid {
    display: grid;
    box-sizing: border-box;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1em;
    align-items: center;
    text-align: center;
    padding:0 10vw 45vh 10vw;
    position:relative;
    z-index:2;

    &.grid.four-up{
      .grid-image{
        /* background:yellow; */
        height:50vh;
      }
    }

    &.grid.two-up{
      .grid-image{
        /* border:4px solid red; */
        height:80vh;
      }
    }

    .grid-image {
      text-align: center;
      align-items: center;
      justify-content: center;
      width:100%;
      max-width:50vw;
      margin:0 auto;

      z-index:10;
    }
  }

  &.inset {

    align-items: center;
    justify-content: center;
    display: grid;

    .inset-image{
      z-index:2;
      position:relative;
      height:80vh;
      width:80vw;

    }
  }

  &.full-bleed {

    display: grid;
    align-items: center;
    box-sizing: border-box;
    text-align:center;
    
    .full-bleed-image {
      height:80vh;
      width:75vw;
      margin:0 auto;
      z-index:2;
      position:relative;
      ${media.medium}{
        width:80vw;

      }

    }
  }

  &.writing {
    background: var(--light);
    color: var(--black);
    text-align: left;
    padding-top: 20vh;
    padding-left: var(--left-margin);
    padding-right: 18vw;
    /* padding-bottom: 20vw; */
    font-family:var(--sans);
    font-size: var(--medium-text);
    /* background:yellow; */

    ${media.large}{
      font-size:var(--large-text);
    }
  }

  &.video {
    background: var(--light);
    color: var(--black);
    align-items: center;
    display: grid;
    
    div {
      margin: 0 auto;
      position:relative;
      z-index:2;
    }

    iframe {
      margin: 0 auto;
      text-align: center;
      position:relative;
      z-index:2;
    }
  }
`

const ArtTitle = styled.h2`
  display: inline-block;
  margin: 20px auto;
  max-width:66vw;
  font-family:var(--serif);
  /* background:var(--light); */
  background:none;
  font-weight: 500;
  font-size: var(--large-text);
  padding: 0.5em 0em;
  margin:0.5em 0;
  z-index:1;
  /* background:yellow; */

  &.hidden{
    opacity:0.0;
  }

`

const TitleContainer = styled.div`
  /* position: absolute; */
  z-index: 10;
  text-align: left;
  width: 100%;
  /* padding-left:5em; */
  padding-left:var(--left-margin);
  z-index:1;
  /* background:red; */


`

const ArtCard = styled.div`

  font-family: var(--sans);
  padding:1em;
  padding-left:0em;
  padding-top:0em;
  padding-bottom:5em;
  box-sizing:border-box;
  text-align:left;
  font-size:var(--small-text);
  margin-left:var(--left-margin);

  ${media.medium}{
    max-width:50vw;
  }

  ${media.large}{
    max-width:40vw;
  }

  p:first-child{
    margin-top:0;
  }

`

const StudentProject = styled.section`
  position: relative;
  margin: 0;
  padding-bottom:25vh;
  /* border-bottom:10px solid blue; */
  &:nth-child(even) {
  }
`

const urlFor = source =>
  urlBuilder({ projectId: 'wupp9sji', dataset: 'production' }).image(source)

const serializer = {
  types: {
    figure: props => (
      <figure>
        <img
          className={props.node.alignment}
          src={urlFor(props.node.image).width(200)}
          alt={props.node.alt}
        />
        <figcaption>{props.node.caption}</figcaption>
      </figure>
    )
  }
}

// a component that shows one image full bleed.
function ArtworkFullBleed ({ slideType, fullBleed }) {
  return (
    <Slide className="full-bleed" name="selectedSlide">
      {/* <h3>ArtworkFullBleed - {slideType}</h3> */}

      <Img className="full-bleed-image" imgStyle={{ objectFit: 'contain' }} fluid={fullBleed.fluid} alt="" />
    </Slide>
  )
}

// a component that displays a video from Vimeo
function ArtworkVideo ({ slideType, url }) {
  return (
    <Slide className="video">
      {/* Documentation for this library: https://github.com/CookPete/react-player */}
      <ReactPlayer width={'80vw'} height={'75vh'} controls={true} url={url} />
    </Slide>
  )
}

//  a component that shows 2 images side by side.
function Artwork2x2 ({ slideType, image01, image02 }) {
  return (
    <Slide className="grid two-up">
      <Img className="grid-image" imgStyle={{ objectFit: 'contain', objectPosition: 'bottom right' }} fluid={image01.fluid} alt="" />

      <Img className="grid-image" imgStyle={{ objectFit: 'contain', objectPosition: 'bottom left' }} fluid={image02.fluid} alt="" />
    </Slide>
  )
}

// a component that shows 4 images
function Artwork4x4 ({ slideType, image01, image02, image03, image04 }) {
  return (
    <Slide className="grid four-up">
      <Img
        className="grid-image"
        imgStyle={{ objectFit: 'contain', objectPosition: 'bottom right' }}
        fluid={image01.fluid}
        alt=""
      />
      <Img
        className="grid-image"
        imgStyle={{ objectFit: 'contain', objectPosition: 'bottom left' }}
        fluid={image02.fluid}
        alt=""
      />
      <Img
        className="grid-image"
        imgStyle={{
          objectFit: 'contain',
          objectPosition: 'top right'
        }}
        fluid={image03.fluid}
        alt=""
      />
      <Img
        className="grid-image"
        imgStyle={{ objectFit: 'contain', objectPosition: 'top left' }}
        fluid={image04.fluid}
        alt=""
      />
    </Slide>
  )
}

// a component that shows one image, smaller within the viewport
function ArtworkInset ({ slideType, inset }) {
  return (
    <Slide className="inset">
      {/* <Zoom
        image={{
          src: inset.fluid.src
        }}
      /> */}
      <Img className="inset-image" imgStyle={{ objectFit: 'contain' }}fluid={inset.fluid} alt="" />
    </Slide>
  )
}

// Does not read for a "writing type" -- read comments in slack
// a component that loads Rich Text
function ArtworkWriting ({ slideType, text }) {
  return (
    <Slide className="writing">
      <PortableText className="work-description" blocks={text} />
    </Slide>
  )
}

function CheckSlideType ({ slide }) {
  // console.log(slide)
  if (slide.__typename === 'SanityFullBleed') {
    return (
      <>
        <span name={slide._key}></span>
        <ArtworkFullBleed
          className="section-trigger"
          fullBleed={slide.asset}
          slideType={slide.__typename}
        ></ArtworkFullBleed>
      </>
    )
  } else if (slide.__typename === 'SanityWorkVideo') {
    return (
      <>
        <span name={slide._key}></span>
        <ArtworkVideo
          url={slide.url}
          slideType={slide.__typename}
        ></ArtworkVideo>
      </>
    )
  } else if (slide.__typename === 'SanityGrid2X2') {
    return (
      <>
        <span name={slide._key}></span>
        <Artwork2x2
          className="section-trigger"
          image01={slide.image_01.asset}
          image02={slide.image_02.asset}
          slideType={slide.__typename}
        ></Artwork2x2>
      </>
    )
  } else if (slide.__typename === 'SanityGrid4X4') {
    return (
      <>
        <span name={slide._key}></span>
        <Artwork4x4
          className="section-trigger"
          image01={slide.grid_image_01.asset}
          image02={slide.grid_image_02.asset}
          image03={slide.grid_image_03.asset}
          image04={slide.grid_image_04.asset}
          slideType={slide.__typename}
        ></Artwork4x4>
      </>
    )
  } else if (slide.__typename === 'SanityInsetImage') {
    return (
      <>
        <span name={slide._key}></span>
        <ArtworkInset
          id="#cover"
          className="section-trigger"
          key={slide.id}
          inset={slide.asset}
          slideType={slide.__typename}
        ></ArtworkInset>
      </>
    )
  } else if (slide.__typename === 'SanityWriting') {
    return (
      <>
        <span name={slide._key}></span>
        <ArtworkWriting
          className="section-trigger"
          text={slide._rawRichText}
          slideType={slide.__typename}
        ></ArtworkWriting>
      </>
    )
  }
}

export default function Artwork ({ artwork }) {
  // const images = [document.querySelectorAll('#cover')]
  // mediumZoom(images)
  const revealRefs = useRef([])
  revealRefs.current = []

  const addToRefs = el => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el)
    }
    console.log(revealRefs.current)
    console.log('hey')
  }

  const [count, setCount] = useState(0)

  const updateCurrentArtwork = () => {
    const i = 1
    return i
  }
  useEffect(() => {
    setCount(document.getElementsByClassName('slide-class').length)

    Events.scrollEvent.register('begin', function () {
      console.log('begin', arguments)
    })

    Events.scrollEvent.register('end', function () {
      console.log('end', arguments)
    })

    gsap.registerPlugin(ScrollTrigger)
    gsap.config({ nullTargetWarn: false })

    const links = gsap.utils.toArray('.section-anim')
    const titles = gsap.utils.toArray('.artwork-title')

    /**
     * Commented out temporarily
     */
    const insets = gsap.utils.toArray('.inset-image')
    const grids = gsap.utils.toArray('.grid-image')
    const bleeds = gsap.utils.toArray('.full-bleed-image')
    const videos = gsap.utils.toArray('.video')
    const cards = gsap.utils.toArray('.art-card')
    const writings = gsap.utils.toArray('.writing')

    // if (writings) {
    //   writings.forEach(writing => {
    //     ScrollTrigger.create({
    //       trigger: writing,
    //       start: 'top top',
    //       toggleClass: { targets: '.artwork-title', className: 'hidden' },
    //       end: () => `+=${writing.offsetHeight}`
    //     })
    //   })
    // }

    if (cards) {
      cards.forEach(card => {
        gsap.to(card, {
          opacity: 0.0,
          scrollTrigger: {
            trigger: card,
            scrub: true,
            start: 'top 3%',
            // end: '+=100'
            end: () => `+=${card.offsetHeight}`
          }
        })
      })
    }

    if (videos) {
      videos.forEach(video => {
        gsap.from(video, {
          y: '-25%',
          scale: 0.7,
          opacity: 0.0,
          scrollTrigger: {
            trigger: video,
            scrub: true,
            start: 'top 95%',
            end: () => `+=${video.offsetHeight}`
          }
        })
      })
    }

    if (bleeds) {
      bleeds.forEach(bleed => {
        gsap.from(bleed, {
          y: '-25%',
          scale: 0.7,
          opacity: 0.0,
          scrollTrigger: {
            trigger: bleed,
            scrub: true,
            start: 'top 95%',
            end: () => `+=${bleed.offsetHeight}`
          }
        })
      })
    }

    if (insets) {
      insets.forEach(inset => {
        gsap.from(inset, {
          y: '-25%',
          scale: 0.7,
          opacity: 0.0,
          scrollTrigger: {
            trigger: inset,
            scrub: true,
            start: 'top 80%',
            end: () => `+=${inset.offsetHeight}`
          }
        })
      })
    }

    if (grids) {
      grids.forEach(grid => {
        gsap.from(grid, {
          y: '-25%',
          scale: 0.7,
          opacity: 0.0,
          scrollTrigger: {
            trigger: grid,
            scrub: true,
            start: 'top 80%',
            end: () => `+=${grid.offsetHeight}`
          }
        })
      })
    }

    const sections = gsap.utils
      .toArray('.student-project')
      .forEach(function (elem) {
        const title = elem.querySelectorAll('.title-container')
        ScrollTrigger.create({
          trigger: elem,
          pin: title,
          scrub: 1,
          start: 'top top',
          // onUpdate: function () { console.log(title[0].offsetHeight) },
          pinSpacing: false,
          end: () => '+=' + (elem.offsetHeight - title[0].offsetHeight)
        })
      })

    // const sections = gsap.utils
    //   .toArray('.title-container')
    //   .forEach(function (elem) {
    //     ScrollTrigger.create({
    //       trigger: elem,
    //       pin: elem,
    //       start: 'bottom bottom',
    //       pinSpacing: false,
    //       end: () => '+=' + (elem.parentElement.clientHeight - elem.offsetHeight * 2)
    //     })
    //   })

    if (links) {
      gsap.to(links, {
        stagger: 0.1,
        scrollTrigger: {
          trigger: '.section-trigger',
          onEnter: () => {
            updateCurrentArtwork()
            // console.log("Enter")
          },
          // onLeave: () => console.log("Leave"),
          onEnterBack: () => {
            updateCurrentArtwork()
            // console.log("Enter Back")
          },
          // onLeaveBack: () => console.log("Leave Back"),
          start: 'top 33%',
          scrub: true
          // markers: true
        }
      })
    }
  })
  return (
    <Project className="student-artwork">
      {artwork.map((work, index) => (
        <StudentProject className="student-project" key={index}>
          <TitleContainer className="title-container">
            <ArtTitle className="artwork-title"> {work.title}</ArtTitle>
          </TitleContainer>
          <ArtCard className="art-card">
            <p>{work.year}</p>
            <PortableText
              className="work-description"
              blocks={work._rawDescription}
            />
            <p>
              {work.materials &&
                <span>
                  Materials:<br/> {work.materials}
                </span>
              }
            </p>
            <p>
              {work.width &&
                <span>
                  {work.width}
                </span>
              }
              {
                work.height &&
                <span>
                  &nbsp;&#xd7; {work.height}
                </span>
              }
              {
                work.depth &&
                <span>
                  &nbsp;&#xd7; {work.depth}
                </span>
              }

            </p>
          </ArtCard>

          {work.slides.map((slide, i) => (
            <CheckSlideType
              slide={slide}
              refs={addToRefs}
              key={i}
            ></CheckSlideType>
          ))}
        </StudentProject>
      ))}
    </Project>
  )
}
